import { MAGAZINE_MODULE_TITLES } from "~constants/magazine";
import type { MagazineIssue, MagazineSection } from "~types/types";

export function getNonFeaturesMagazineModules(magazineIssue: MagazineIssue) {
    return (
        magazineIssue.modules?.filter(
            (module: MagazineSection) =>
                module.title !== MAGAZINE_MODULE_TITLES.FEATURE
        ) || []
    );
}

export function getFeaturesMagazineModules(magazineIssue: MagazineIssue) {
    return (
        magazineIssue.modules?.filter(
            (module: MagazineSection) =>
                module.title === MAGAZINE_MODULE_TITLES.FEATURE
        ) || []
    );
}
